import React, { useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { Switch } from "antd";
import { useNavigate } from "react-router-dom";

import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import { useTranslation } from "react-i18next";
import { API_CREATE_FAQ } from "api/faq-managemnt";

const CreateFaq = () => {
  const { t } = useTranslation();
  const Navigate = useNavigate();

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              question: "",
              answer: "",
            }}
            validationSchema={Yup.object({
              question: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              answer: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              try {
                const userData = await API_CREATE_FAQ(values);

                toast.success(userData?.message);
                Navigate("/admin/faq/faq-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Question")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="question"
                        placeholder={t("Question")}
                        // maxLength={20}
                        // onKeyPress={(event) => {
                        //   const charCode = event.charCode;
                        //   if (
                        //     !(charCode >= 65 && charCode <= 90) && // A-Z
                        //     !(charCode >= 97 && charCode <= 122) && // a-z
                        //     charCode !== 32 // space
                        //   ) {
                        //     event.preventDefault();
                        //   }
                        // }}
                      />
                      <ErrorMessage
                        name="question"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Answer")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="answer"
                        placeholder={t("Answer")}
                      />
                      <ErrorMessage
                        name="answer"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Creating..." : " Create Role"} */}
                    {isSubmitting ? t("Creating") + "..." : t("Create Faq")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateFaq;
